/**
 * Page Header behaviour
 *
 * Reduce header height smaller after scrolling
 * On DOM ready
 */
import {Utils} from "./Utils";

Utils.executeWhenDocumentIsReady( () => {
    const settings: { startAt: number, elementAttributeName: string, scrollAttributeName: string } = {
        startAt: 12,
        elementAttributeName: '[data-header-scroll]',
        scrollAttributeName: 'data-header-on-content'
    };

    let target: HTMLElement | null = document.querySelector(settings.elementAttributeName),
        headerLogo: HTMLElement | null = document.querySelector('.c-header__logo'),
        headerMainNav: HTMLElement | null = document.querySelector('.c-header__main-nav');

    if (target) {
        setAttributeState(target, settings);

        window.addEventListener('scroll', function () {
            if (target) setAttributeState(target, settings);
        });

        window.addEventListener('resize', function () {
            setTimeout(adjustMegaMenuHeight, 210);
        });
    }

    // Main Nav and Logo Alignment Start //
    function adjustNavAndLogo() {
        if (headerLogo && headerMainNav) {
            let logoOffset = headerLogo.getBoundingClientRect();
            let logoWidth = headerLogo.offsetWidth;
            let navOffset = headerMainNav.getBoundingClientRect();
            let navWidth = headerMainNav.offsetWidth;

            if (logoOffset.left <= 0) {
                headerLogo.classList.add('c-header__logo--left');
            }

            if (window.innerWidth > logoWidth * 3 + navWidth && target && target.getAttribute(settings.scrollAttributeName) === 'true') {
                headerLogo.classList.remove('c-header__logo--left');
            }

            if (window.innerWidth > logoWidth * 2 + navWidth && target && target.getAttribute(settings.scrollAttributeName) === 'false') {
                headerLogo.classList.remove('c-header__logo--left');
            }

            if (navOffset.left < logoWidth) {
                if (window.innerWidth >= 1008 && window.scrollY === 0) {
                    logoWidth = 224;
                }
                let paddingLeft = 24 + logoWidth - ((window.innerWidth - navWidth) / 2);
                headerMainNav.style.paddingLeft = `${paddingLeft}px`;
            } else {
                headerMainNav.style.paddingLeft = '';
            }
        }
    }

    // Main Nav and Logo Alignment End //

    // Meta Dropdown Start //
    let metaDropdowns = Array.from(document.querySelectorAll<HTMLElement>('[data-meta-dropdown]')),
        metaDropdownButtons = Array.from(document.querySelectorAll<HTMLElement>('[data-meta-dropdown-button]')),
        metaDropdownActiveClass = 'c-header__meta-dropdown--active';

    metaDropdownButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            let i = button.getAttribute('data-meta-dropdown-button');
            if (document.querySelector(`[data-meta-dropdown='${i}']`)?.classList.contains(metaDropdownActiveClass)) {
                CloseAllMetaDropdowns();
            } else {
                OpenMetaDropdown(i);
            }
        });
    });


    function OpenMetaDropdown(i) {
        CloseAllMetaDropdowns();
        document.querySelector(`[data-meta-dropdown='${i}']`)?.classList.add(metaDropdownActiveClass);
    }

    function CloseAllMetaDropdowns() {
        metaDropdowns.forEach(function (dropdown) {
            dropdown.classList.remove(metaDropdownActiveClass);
        });
    }

    document.body.addEventListener('click', function (e) {
        let target = e.target as HTMLElement;
        if (![...metaDropdowns].some(dropdown => dropdown.contains(target)) && ![...metaDropdownButtons].some(button => button.contains(target))) {
            CloseAllMetaDropdowns();
        }
    });
    // Meta Dropdown End //

    // Megamenu Start //
    let megamenu = document.querySelector<HTMLElement>('[data-megamenu]'),
        megamenuTrigger = document.querySelectorAll('[data-megamenu-trigger]'),
        megamenuContents = document.querySelectorAll('[data-megamenu-content]'),
        megamenuClose = document.querySelector('[data-megamenu-close]'),
        currentMenuItem = document.querySelector<HTMLElement>('.c-header__main-nav-link--current'),
        megamenuMenuTrigger = document.querySelectorAll('[data-megamenu-menu-trigger]'),
        megamenuSubmenuClose = document.querySelectorAll('[data-megamenu-submenu-close]'),
        megamenuContentActiveClass = 'c-megamenu__content--active',
        megamenuTriggerActiveClass = 'c-header__main-nav-link--active',
        megamenuActiveClass = 'c-megamenu--active';

    megamenuTrigger.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            let i = parseInt(trigger.getAttribute('data-megamenu-trigger'));
            megamenuTrigger.forEach(function (trigger) {
                trigger.classList.remove(megamenuTriggerActiveClass);
            });
            if (i > 0) {
                trigger.classList.add(megamenuTriggerActiveClass);
                openMegaMenuContent(i);
            }
        });
    });

    megamenuMenuTrigger.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            let contentIndex = trigger.closest('[data-megamenu-content]').getAttribute('data-megamenu-content'),
                columnIndex = trigger.closest('[data-megamenu-column]').getAttribute('data-megamenu-column'),
                submenuIndex = trigger.getAttribute('data-megamenu-menu-trigger'),
                allMegamenuColumns = document.querySelectorAll(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column]`),
                allMegamenuLists = document.querySelectorAll(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column='${columnIndex}'] .c-megamenu__list`),
                currentColumn = document.querySelector(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column='${columnIndex}']`),
                currentList = document.querySelector(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column='${columnIndex}'] [data-megamenu-menu='${submenuIndex}']`);
            if (!currentColumn.classList.contains('c-megamenu__column--disabled')) {
                allMegamenuLists.forEach(function (list) {
                    list.classList.add('c-megamenu__list--hide-items');
                });
                allMegamenuColumns.forEach(function (column) {
                    column.classList.add('c-megamenu__column--disabled');
                });
                currentList.classList.remove('c-megamenu__list--hide-items');
                currentColumn.classList.remove('c-megamenu__column--disabled');
            }
            if (currentList.getAttribute('data-megamenu-first-level')) {
                allMegamenuColumns.forEach(function (column) {
                    column.classList.remove('c-megamenu__column--disabled');
                });
            }
        });
    });

    megamenuSubmenuClose.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
            let contentIndex = closeButton.closest('[data-megamenu-content]').getAttribute('data-megamenu-content'),
                columnIndex = closeButton.closest('[data-megamenu-column]').getAttribute('data-megamenu-column'),
                allMegamenuColumns = document.querySelectorAll(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column]`),
                allMegamenuLists = document.querySelectorAll(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column='${columnIndex}'] .c-megamenu__list`),
                currentList = document.querySelector(`[data-megamenu-content='${contentIndex}'] [data-megamenu-column='${columnIndex}'] [data-megamenu-first-level]`);
            allMegamenuLists.forEach(function (list) {
                list.classList.add('c-megamenu__list--hide-items');
            });
            currentList.classList.remove('c-megamenu__list--hide-items');
            allMegamenuColumns.forEach(function (column) {
                column.classList.remove('c-megamenu__column--disabled');
            });
        });
    });

    megamenuClose.addEventListener('click', function () {
        closeMegaMenu();
    });

    function openMegaMenuContent(i) {
        if (!megamenu.classList.contains(megamenuActiveClass)) {
            megamenu.classList.add(megamenuActiveClass);
        }
        closeAllMegaMenuContents();
        document.querySelector(`[data-megamenu-content='${i}']`).classList.add(megamenuContentActiveClass);

        if (document.querySelector('.c-megamenu__list--lvl-3').querySelector('.c-megamenu__link--active')) {
            let activeMegamenuItem = document.querySelector('.c-megamenu__list--lvl-3').querySelector('.c-megamenu__link--active');
            activeMegamenuItem.closest('.c-megamenu__list--lvl-2').classList.add('c-megamenu__list--hide-items');
            activeMegamenuItem.closest('.c-megamenu__list--lvl-3').classList.remove('c-megamenu__list--hide-items');
        }
    }

    function closeAllMegaMenuContents() {
        megamenuContents.forEach(function (content) {
            content.classList.remove(megamenuContentActiveClass);
        });
    }

    function closeMegaMenu() {
        megamenu.classList.remove(megamenuActiveClass);
        megamenuTrigger.forEach(function (trigger) {
            trigger.classList.remove(megamenuTriggerActiveClass);
        });
        if (currentMenuItem) {
            currentMenuItem.classList.add(megamenuTriggerActiveClass);
        }
        closeAllMegaMenuContents();
    }

    document.body.addEventListener('click', (e: MouseEvent) => {
        const megamenuTrigger = document.querySelectorAll<HTMLElement>('[data-megamenu-trigger]');
        if (!megamenu.contains(e.target as Node) && !Array.from(megamenuTrigger).some((trigger) => trigger.isSameNode(e.target as Node))) {
            closeMegaMenu();
        }
    });

    function adjustMegaMenuHeight(): void {
        const headerElement = document.querySelector('.c-header') as HTMLElement;
        const menuElements = document.querySelectorAll('.c-megamenu__content-wrapper');

        const height = window.innerHeight - headerElement.offsetHeight;

        menuElements.forEach((menuElement: Element) => {
            (menuElement as HTMLElement).style.maxHeight = `${height}px`;
        });
    }

    // Megamenu End //

    /**
     * Set scrollAttributeName value to true or false
     * @param target
     */
    function setAttributeState(target: string | HTMLElement, settings: { startAt: number, scrollAttributeName: string }): void {
        const targetElement = typeof target === 'string' ? document.querySelector<HTMLElement>(target) : target;
        const autoSuggestElement = document.querySelector<HTMLElement>('.header-auto-suggest');

        if (window.pageYOffset >= settings.startAt) {
            if (targetElement.getAttribute(settings.scrollAttributeName) !== 'true') {
                targetElement.setAttribute(settings.scrollAttributeName, 'true');
                setTimeout(adjustMegaMenuHeight, 210);

                if (autoSuggestElement) {
                    autoSuggestElement.classList.add('header-auto-suggest--small-header');
                }
            }
        } else {
            targetElement.setAttribute(settings.scrollAttributeName, 'false');
            setTimeout(adjustMegaMenuHeight, 210);

            if (autoSuggestElement) {
                autoSuggestElement.classList.remove('header-auto-suggest--small-header');
            }
        }
    }

});
